import React from 'react';
import GoalStep from './GoalStep';
import AssetsStep from './AssetsStep';
import ResultsStep from './ResultsStep';
import ProgressMeter from '../OwnerDiagnostic/ProgressMeter';

class PersonalFinancialReadiness extends React.Component {
  constructor(props) {
    super(props);
    const u = props.user || {};
    this.state = {
      step: 0,
      values: {
        goal_type: u.readiness_goal_type || 'lump_sum',
        goal_lump_sum: u.readiness_goal_lump_sum || 0,
        annual_income: u.readiness_goal_annual_income || 0,
        withdrawal_rate: (u.readiness_withdrawal_rate == null ? 0.04 : u.readiness_withdrawal_rate),
        current_investable_assets: u.readiness_current_investable_assets || 0,
        include_illiquid: u.readiness_include_illiquid || false,
      }
    };
  }

  update = (patch) => {
    this.setState({ values: { ...this.state.values, ...patch } });
  };

  next = () => this.setState({ step: Math.min(this.state.step + 1, 2) });
  back = () => this.setState({ step: Math.max(this.state.step - 1, 0) });

  handleSave = async (patch) => {
    const newVals = { ...this.state.values, ...patch };
    this.setState({ values: newVals });
    await this.props.onSave(newVals);
  };

  componentDidMount() {
    if (this.props.track) {
      this.props.track('readiness_view_started', { entryPoint: 'direct' });
    }
  }

  render() {
    const { saving, user, track } = this.props;
    const { step, values } = this.state;
    return (
      <div className="flex min-h-screen bg-succession-bg-secondary transition-colors duration-300">
        <div className="flex-1 flex flex-col overflow-hidden">
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-succession-bg-secondary p-6 transition-colors duration-300">
            <div className="max-w-5xl mx-auto">
              <div className="px-1 md:px-0 mb-3">
                <ProgressMeter current={Math.min(step, 2)} total={3} />
              </div>
              <div className="bg-white rounded-lg shadow border border-succession-border p-6">
                <h1 className="text-2xl font-bold text-succession-text-primary mb-1">Define your Wealth Goal</h1>
                <p className="text-succession-text-secondary mb-6">Define your goal, add your current investable assets, and review your Wealth Gap with next-step recommendations.</p>

                {step === 0 && (
                  <GoalStep values={values} onChange={this.update} onSave={this.handleSave} onNext={this.next} saving={saving} track={track} />
                )}
                {step === 1 && (
                  <AssetsStep values={values} onChange={this.update} onSave={this.handleSave} onNext={this.next} onBack={this.back} saving={saving} track={track} />
                )}
                {step === 2 && (
                  <ResultsStep user={user} onBack={this.back} track={track} />
                )}
              </div>
            </div>
          </main>
        </div>
      </div>
    );
  }
}

export default PersonalFinancialReadiness;


